import React, {Component} from 'react';
import config from '../../config/config.js';
import axios from 'axios';

class SSPState extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        if (this.props.handleSaveStart) {
            this.props.handleSaveStart(this.props.id);
        }
        axios(config.server.endpoint + 'backend/shift/changeShiftSupporterProjectState/' + this.props.id + '/' + this.props.newState, {
            method: 'put'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.props.handleSaveSuccess();
                }
            }
        });
    }

    render() {
        return (
            <button className={"SSPState btn btn-" + this.props.style} onClick={this.handleClick} title={this.props.newState} disabled={this.props.disabled}>
                <i className={"fa fa-" + this.props.icon}/>
            </button>
        )
    }
}
export default SSPState;